"use strict";

import Page from "./AddAttendantMonitoringCompany.tsx";

export const auth = true;

export const Component = Page;
